export default __webpack_public_path__ + "static/open-graph-af2444a7f4acd8fed8bc832044935925.png";